import React from 'react';
import {
    Flex,
    Header,
    List,
    pxToRem,
    useStyles,
    useTheme,
} from '@archipro-design/aria';
import * as S from './MetricStats.style';
import { Link } from '@remix-run/react';

interface Props {
    stats: {
        label: string;
        data: string;
        testID: string;
        additionalContent?: React.ReactNode;
        link?: string;
    }[];
}

const MetricStats = ({ stats }: Props) => {
    const { css } = useStyles();

    const { siteVariables } = useTheme();
    const items = stats.map((s) => ({
        label: s.label,
        customChildComponent: (
            <>
                <Flex hAlign="end">
                    <Header
                        as="h3"
                        className={css(S.MetricText)}
                        data-testid={s.testID}
                        variables={{
                            color: siteVariables.colorScheme.default!
                                .foreground,
                            fontSize: pxToRem(55),
                            lineHeight: pxToRem(60.5),
                        }}
                    >
                        {s.link ? (
                            <Link to={s.link} prefetch="intent">
                                {s.data}
                            </Link>
                        ) : (
                            s.data
                        )}
                    </Header>
                </Flex>
                {s.additionalContent}
            </>
        ),
    }));

    return (
        <div className={css(S.MetricStatsWrapper)}>
            <List
                items={items}
                className={css(S.MetricStatsContainer)}
                variables={{
                    listBorderColor: siteVariables.colors.primitive.black,
                }}
            />
        </div>
    );
};

export default MetricStats;
